// extracted by mini-css-extract-plugin
export var container = "_2k-0";